import { MEDAL_EVENT_SORTS } from "@seagames/contracts";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";
import { z } from "zod";
import { type DashboardSearch, DashboardPage } from "../../components/dashboard/dashboard-page";

const DAY = /^\d{4}-\d{2}-\d{2}$/;

/**
 * The dashboard's URL: the selected day (`?day=`) and the medal events table's
 * filters (`state`, `sport`, `q`, `due`, `sort`, `page`), so the pipeline's
 * links and a shared address land on the same view. A malformed value is
 * dropped, never an error page.
 */
const dashboardSearch = z.object({
	day: z.string().regex(DAY).optional().catch(undefined),
	state: z.string().max(200).optional().catch(undefined),
	sport: z.string().uuid().optional().catch(undefined),
	q: z.string().trim().min(1).max(100).optional().catch(undefined),
	due: z.string().regex(DAY).optional().catch(undefined),
	sort: z.enum(MEDAL_EVENT_SORTS).optional().catch(undefined),
	page: z.coerce.number().int().min(1).max(10_000).optional().catch(undefined),
});

/** MSES's home: the medal board (components/dashboard/dashboard-page.tsx). */
export const Route = createFileRoute("/_app/")({
	validateSearch: dashboardSearch,
	component: function Dashboard() {
		const search = Route.useSearch();
		const navigate = useNavigate({ from: Route.fullPath });
		const go = useCallback(
			(patch: Partial<DashboardSearch>, hash?: string) => void navigate({ search: (s) => ({ ...s, ...patch }), replace: true, resetScroll: false, ...(hash ? { hash } : {}) }),
			[navigate],
		);
		return <DashboardPage search={search} navigate={go} />;
	},
});
